const t = ["sm", "md", "lg", "xl"], s = {
  CALLBAR_BUTTON_VALID_WIDTH_SIZE: t
};
export {
  t as CALLBAR_BUTTON_VALID_WIDTH_SIZE,
  s as default
};
//# sourceMappingURL=callbar-button-constants.js.map
